import { Skeleton } from '@mui/material';
import styles from './SkeletonFacets.module.scss';

const SkeletonFacet = () => {
  return (
    <div className={styles.facetContainer}>
      <Skeleton variant="rounded" className={styles.title} />
      <Skeleton variant="rounded" className={styles.facet1} />
      <Skeleton variant="rounded" className={styles.facet2} />
      <Skeleton variant="rounded" className={styles.facet3} />
      <Skeleton variant="rounded" className={styles.facet4} />
    </div>
  );
};

const SkeletonFacets = () => {
  return (
    <div>
      <SkeletonFacet />
      <SkeletonFacet />
    </div>
  );
};

export default SkeletonFacets;
